import { H as Host, g as effect, s as setAttribute } from './vidstack-Uw94Yvrg.js';
import { P as Poster } from './vidstack-DLpJQ4a5.js';
import './vidstack-DSCDp3Na.js';
import './vidstack-BYKVJb7W.js';
import './vidstack-Dchp6m-3.js';
import './vidstack-D73YzvPy.js';
import './vidstack-VrKElWm_.js';
import './vidstack-69_0Ad1E.js';
import './vidstack-ByTY2VS-.js';
import './vidstack-Du-_dEIb.js';
import './vidstack-BSXZsAhp.js';
import './vidstack-BUqeBbTQ.js';
import './vidstack-ksPACRiU.js';
import './vidstack-CSaHpIQV.js';

class MediaPosterElement extends Host(HTMLElement, Poster) {
  constructor() {
    super(...arguments);
    this.Wm = document.createElement("img");
  }
  static {
    this.tagName = "media-poster";
  }
  static {
    this.attrs = {
      crossOrigin: "crossorigin"
    };
  }
  onSetup() {
    this.$state.img.set(this.Wm);
  }
  onConnect() {
    const { src, alt, crossOrigin } = this.$state;
    if (this.Wm.parentNode !== this) {
      this.prepend(this.Wm);
    }
    effect(() => {
      setAttribute(this.Wm, "alt", alt());
      setAttribute(this.Wm, "crossorigin", crossOrigin());
      setAttribute(this.Wm, "src", src() || "");
    });
    effect(() => {
      const { loading, hidden } = this.$state;
      this.Wm.style.display = loading() || hidden() ? "none" : "";
    });
  }
}

export { MediaPosterElement };
